import { render } from "./BaseSubmittingOverlay.vue?vue&type=template&id=d105c036&scoped=true&ts=true"
import script from "./BaseSubmittingOverlay.vue?vue&type=script&lang=ts"
export * from "./BaseSubmittingOverlay.vue?vue&type=script&lang=ts"

import "./BaseSubmittingOverlay.vue?vue&type=style&index=0&id=d105c036&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d105c036"]])

export default __exports__